document.addEventListener('teeinblue-event-after-cart-added', function() {
  fetch('/cart.js', { method: 'GET' })
  .then((response) => response.json())
  .then((cart) => {
    const cartCountList = document.querySelectorAll('cart-count')
    
    cartCountList.forEach((item) => {
      if(cart.item_count > 0) {
        item.removeAttribute("hidden"); 
      }
      if (cart.item_count > 99) {
        item.innerHTML = `<span class="text-sm">99+</span>`;
        item.classList.add('cart-count--small-medium');
      } else {
        item.innerText = cart.item_count;
        item.classList.remove('cart-count--small-medium');
      }
    })

    // Bij een normale add-to-cart zet het theme deze class op <html>
    // (theme.js, CartCount.onCartUpdate). Teeinblue gebruikt zijn eigen event,
    // waardoor de class achterbleef en .header__buttons zijn
    // margin-inline-end: -1.2rem hield. Daardoor stond het aantal-bolletje na
    // het toevoegen op de verkeerde plek.
    document.documentElement.classList[cart.item_count === 0 ? 'remove' : 'add']('cart-has-items');
  })
  .catch((error) => {
    console.error('Error refreshing cart drawer:', error);
  });
  
  document.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true, detail: { open: true }
  }));
});

// Laad-cirkeltje direct tonen bij een Teeinblue add-to-cart.
//
// Teeinblue vangt de klik op de add-to-cart-knop af, maakt eerst de
// personalisatie aan op zijn eigen server en klikt daarna zelf op de knop.
// Het theme zet btn--loading pas bij die tweede klik (theme.js,
// ProductForm.handleFormSubmit), waardoor het cirkeltje pas ~2 seconden na de
// klik van de klant verscheen.
//
// Teeinblue stuurt teeinblue-event-before-customization-created zodra de
// validatie geslaagd is (dus niet als er nog een foto ontbreekt). Op dat
// moment zetten we btn--loading al op de geklikte knop. Bewust geen
// aria-disabled: daarmee slaat ProductForm de submit van Teeinblue over.
(function () {
  let clickedButton = null;

  // Capture op document loopt vóór de capture-listener van Teeinblue, die de
  // klik daarna stopt.
  document.addEventListener('click', function (event) {
    const button = event.target.closest && event.target.closest('button[name="add"]');
    clickedButton = button && button.closest('form[is="product-form"]') ? button : null;
  }, true);

  document.addEventListener('teeinblue-event-before-customization-created', function () {
    const button = clickedButton;
    if (!button) return;

    button.classList.add('btn--loading');

    // Teeinblue haalt disabled weg vlak voordat het zelf klikt; het theme zet
    // dan direct aria-disabled en neemt het cirkeltje over. Gaat het aanmaken
    // mis, dan haalt Teeinblue disabled weg zonder te klikken: dan het
    // cirkeltje weer weghalen.
    const observer = new MutationObserver(function () {
      if (button.hasAttribute('disabled')) return;
      observer.disconnect();
      if (button.getAttribute('aria-disabled') !== 'true') {
        button.classList.remove('btn--loading');
      }
    });
    observer.observe(button, { attributes: true, attributeFilter: ['disabled'] });
  });
})();
